// material-ui
import { Box } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import getMenuItems from 'menu-items';

import { useSelectedShopId } from 'hooks/common/selectedShopId';
import { useLang } from 'hooks/common/lang';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
    const { selectedShop, permissions: permission } = useSelectedShopId();
    const { $t } = useLang();

    let isVerified = selectedShop?.isVerified ?? false;

    const navGroups = getMenuItems({ isVerified, $t, permission }).items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return null;
        }
    });

    return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
